import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bill",
  "use": "icon-bill-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bill\"><path d=\"M5 22a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v5h1.5a1.5 1.5 0 0 1 1.5 1.5V19a3 3 0 0 1-3 3H5ZM16 5H5v15h11V5Zm3 7h-1v8l.117-.007a1 1 0 0 0 .876-.876L19 19v-7Zm-8 1a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h3Zm2-5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2h5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol